import React from "react";
import dayjs from "dayjs";
import { transactionTypes } from "../data/transactionTypes.tsx";
import { categories } from "../data/categories.tsx";

type Props = {
  title: string;
  date: string; // ISO string
  type: string; // matches transactionTypes ids
  amount: number;
  currency: string;
  categoryId?: string;
};

const formatDate = (dateString: string) => dayjs(dateString).format("DD MMM YYYY");

export default function TransactionItem({ title, date, type, amount, currency, categoryId }: Props) {
  const tType = transactionTypes.find((t) => t.id === type);
  const category = categories.find((c) => c.id === (categoryId || ""));

  return (
    <div className="card-glass p-4 hover:bg-white/10 transition flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <div className="text-2xl">{category?.icon ?? "•"}</div>
        <div>
          <p className="font-medium text-slate-100">{title}</p>
          <p className="text-sm text-slate-400">
            {formatDate(date)} • {tType?.name ?? type}
          </p>
        </div>
      </div>
      <div className={`font-semibold ${tType?.color ?? "text-gray-300"}`}>
        {tType?.operator ?? ""} {currency} {Number(amount).toFixed(2)}
      </div>
    </div>
  );
}

